module.exports = __webpack_public_path__ + "img/Checkmark-Light.a533c465.svg";